const textFieldFormParamUser = {
  name: 'Nome Completo',
  email: 'E-mail',
  
};

export default textFieldFormParamUser;
